import PropTypes from "prop-types"
import { AppBar } from "@mui/material"
import { Link } from "react-router-dom"
import Logo from "components/logo"
import ServerNotifications from "modules/server-notifications"
import HelpMenu from "modules/help-menu"

export default function HomeHeader({ account, Icon, title, children, className, modelId }) {
  return <AppBar position="sticky" className={className}>
    <div className="header-app-bar">
      <div className="left">
        <Link className="logo" to={`/${account}/home`}>
          <Logo />
        </Link>
        <Icon />
        <span className="title">{title}</span>
        {children}
      </div>
      <div className="right">
        <ServerNotifications homeVersion />
        <HelpMenu iconButton modelId={modelId} />
      </div>
    </div>
  </AppBar>
}

HomeHeader.propTypes = {
  account: PropTypes.string.isRequired,
  Icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  help: PropTypes.element,
  className: PropTypes.string,
  modelId: PropTypes.string,
}
